import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { MaskedLines } from "@/components/Motion";
import { ChatButton } from "@/components/Cta";

export default function NotFound() {
  return (
    <>
      <Seo title="找不到这个页面 | TKShopMY" description="你要找的页面不存在。" path="/404" noindex />
      <section className="flex min-h-[80vh] items-center pt-24" data-testid="not-found-page">
        <div className="mx-auto max-w-3xl px-5 text-center md:px-8">
          <p className="font-display text-lg italic text-moss">404</p>
          <MaskedLines
            className="mt-4 font-display text-4xl font-medium leading-[1.15] sm:text-5xl"
            lines={[<>这个页面</>, <>已经<span className="text-moss">下架</span>了。</>]}
          />
          <p className="mx-auto mt-6 max-w-md text-base text-ink/60">
            你要找的页面不存在 —— 但你对 TikTok Shop 的问题，还是有答案的。
          </p>
          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <ChatButton location="404" variant="primary" testId="notfound-chat-button">
              WhatsApp 咨询
            </ChatButton>
            <Link
              to="/"
              className="rounded-full border border-ink/20 px-7 py-3.5 text-base font-semibold text-ink transition-colors hover:border-forest hover:text-forest"
              data-testid="notfound-home-link"
            >
              回到首页
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
